module.exports = __webpack_public_path__ + "static/img/logo_10541.7e30e8c.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo/logo_10541.png
// module id = yxrX
// module chunks = 167